/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import WithApa from 'newComponents/WithApa/WithApa';
import _ from 'lodash';
import { Form } from 'cvlib';
import Utils from 'utils/Utils';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import './ConfirmTransaction.scss';
import { GetRegion, PLAYER_SEGMENT } from 'constants.js';
import { pushGTMEvent } from '../../Player/utils/analytics';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getQueryParamsObject } from 'utils/getQueryParamsObject';
import {
  getTranslation,
  getTranslationEmptyOrNullKey,
} from '../../../utils/getTranslation';
import { store } from 'store';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import { getContentSerie } from 'action-creators/content/series';
import { getContentDataByGroupId } from 'containers/Player/actions/content/content.actions';
import { clearCurrentWFS } from 'action-creators/payway/currentPayment/currentWFS';
import { clearCurrentPurchaseConfirmation } from 'action-creators/payway/currentPayment/currentPurchaseConfirmation';
import { CLEAR_PURCHASE_CONFIRMATION } from 'actions/payway';
import { getDefaultCard } from '../utils/getDefaultCard';
import getFirstNode from 'utils/getFirstNode';
import { useEpg } from 'context/EpgContext';

const ConfirmTransaction = ({
  asset,
  translations,
  returnTo,
  is2faFlow,
  hidePortal = () => {},
  hideAndResume = () => {},
  groupId: groupIdFromProps,
  playerUrl: playerUrlFromProps,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const [keys, setKeys] = useState({});
  const purchaseResponse = useSelector(
    state => state.payway.purchaseConfirmation,
  );
  const dispatch = useDispatch();

  const currentPayment = useSelector(state => state.payway.currentPayment);
  const workflow = useSelector(state => state.payway.workflowStart.data);

  const vcardInfo = useSelector(state => state.Vcard);
  const navigation = useSelector(state => state.navigation.model);
  const hasClaroAdActive = getClaroAdsKey(store?.getState());

  const seriesContent = useSelector(state => state.content.series.data);
  const unitarioContent = useSelector(store => store.Player.Content);
  const { refreshEpg } = useEpg()

  const { mail_modal_icon_confirm } = asset;

  const isSerie = !!unitarioContent?.data?.group?.common?.extendedcommon?.media
    ?.serie;

  const handleClear = () => {
    dispatch(clearCurrentWFS());
    dispatch(clearCurrentPurchaseConfirmation());
    dispatch({ type: CLEAR_PURCHASE_CONFIRMATION });
  };

  React.useEffect(
    () => {
      const groupId = groupIdFromProps;

      if (workflow?.workflow?.contentId || groupId) {
        if (isSerie) {
          dispatch(
            getContentSerie({
              group_id: workflow?.workflow?.contentId || groupId,
            }),
          );
        } else {
          dispatch(
            getContentDataByGroupId(workflow?.workflow?.contentId || groupId),
          );
        }
      }
    },
    [workflow?.workflow?.contentId, isSerie],
  );

  useEffect(
    () => {
      const {
        family,
        currency,
        price,
        periodicity,
        bonus,
        oneoffertype,
        frequency,
        producttype,
        translation,
      } = currentPayment?.currentPBI || {};

      const periodEsp = {
        month: 'mes',
        year: 'año',
        hour: 'horas',
      };
      const monthEsp = {
        JAN: 'Enero',
        FEB: 'Febrero',
        MAR: 'Marzo',
        APR: 'Abril',
        MAY: 'Mayo',
        JUN: 'Junio',
        JUL: 'Julio',
        AUG: 'Agosto',
        SEP: 'Septiembre',
        SEPT: 'Septiembre',
        OCT: 'Octubre',
        NOV: 'Noviembre',
        DEC: 'Diciembre',
      };

      const { end_date } = purchaseResponse?.data || {};
      let endDate;
      if (oneoffertype === 'download_rent' || oneoffertype === 'rent') {
        if (periodicity === 'hour') {
          endDate = `${frequency} ${getTranslation(
            periodicity,
            translations,
          )} ${getTranslation(
            'ticket_subscription_sufixDurationRent_label',
            translations,
          )}`;
        }
      } else if (end_date) {
        endDate = `${end_date?.day || ''} ${monthEsp?.[end_date.month] || ''} ${
          end_date.year
        }`;
      }

      let logo = `<div class="logo--container">
      <img src="${asset[`transactional_${family}_logo`]}" />
      <img src="${mail_modal_icon_confirm}" />
      </div>`;

      let description = getTranslation(
        `Ticket_Transaccion_TextoDescripcion_${producttype}`,
        translations,
      );

      let bonusText = `<span class="promo--text">
       ${getTranslation(
         `Ticket_Transaccion_TextoPromocion_${producttype}`,
         translations,
       )}
        </span>`;

      if (
        oneoffertype === 'download_rent' ||
        oneoffertype === 'rent' ||
        oneoffertype === 'download_buy'
      ) {
        const { contentInfo } = workflow?.workflow || {};

        const fallBackTitle = isSerie
          ? seriesContent?.response?.title
          : unitarioContent?.data?.group?.common?.title;

        const title = contentInfo?.contentTitle || fallBackTitle || '';
        logo = `<div class="logo--container logowithmargin">
          <span>${title || ''}</span>
          <img src="${mail_modal_icon_confirm}" />
          </div>`;
        description = `<span class="rent-amount">${currency || ''}${price ||
          ''}</span> 
        <span class="rent-currency">/ ${frequency || ''} 
        ${periodEsp?.[periodicity] || ''}
        </span> 
        ${getTranslation(
          `${producttype}_subscriptionDescription_costTaxIncluded_label`,
          translations,
        )}
        `;

        if (oneoffertype === 'download_buy') {
          description = `<span class="rent-amount">${currency || ''}${price ||
            ''}</span> 
          ${getTranslation(
            `${producttype}_subscriptionDescription_costTaxIncluded_label`,
            translations,
          )}`;
        } else {
          description = `<span class="rent-amount">${currency || ''}${price ||
            ''}</span> 
          <span class="rent-currency">/ 
          ${frequency || ''}
           ${periodEsp?.[periodicity] || ''}
          </span>
           ${getTranslation(
             `${producttype}_subscriptionDescription_costTaxIncluded_label`,
             translations,
           )}`;
        }

        bonusText = '';
      }

      let account = '';
      const getCardDefault = gateway => {
        const workflowListCard =
          workflow?.list || workflow?.workflow?.listBuyLinks;

        const medio = workflowListCard?.find(
          option => gateway === option?.gateway,
        );

        const defaultCard = getDefaultCard(medio?.paymentMethodData?.cardsData);
        const cardSelect =
          defaultCard?.pan ||
          currentPayment?.currentPurchaseConfirmation?.creditCard?.dataCard
            ?.number;
        const MaskedCard = ` ****${cardSelect?.substr(-4)}` || '';
        return MaskedCard;
      };

      if (
        currentPayment?.currentWFS?.paymentMethodData &&
        currentPayment?.currentWFS?.paymentMethodData?.account
      ) {
        account = currentPayment?.currentWFS?.paymentMethodData?.account || '';
      } else if (
        purchaseResponse?.data?.paymentMethodData?.gateway === 'claropagosgate'
      ) {
        account = getCardDefault(
          purchaseResponse?.data?.paymentMethodData?.gateway,
        );
      } else if (
        currentPayment?.currentPurchaseConfirmation &&
        currentPayment?.currentPurchaseConfirmation?.account
      ) {
        account = `${'*'.repeat(
          Math.abs(
            currentPayment.currentPurchaseConfirmation.account.length - 4,
          ),
        )}${currentPayment.currentPurchaseConfirmation.account.substr(
          currentPayment.currentPurchaseConfirmation.account.length - 4,
        )}`;
      }
      let acceptTxt = getTranslation(
        'ticket_subscription_option_button_next',
        translations,
      );
      if (searchParams.get('player_url') || is2faFlow) {
        acceptTxt = getTranslationEmptyOrNullKey(
          'Transaccionales_Ticket_TextoBotonPrimarioReproducir',
          translations,
        );
      }

      let textFrequency = '';

      switch (oneoffertype) {
        case 'download_rent':
        case 'rent':
          textFrequency = hasClaroAdActive
            ? `${price?.currency || ''} ${price?.amount ||
                ''} ${translation?.labelTaxes || ''}`
            : `${currency || ''}${price || ''} ${getTranslation(
                `${producttype}_subscriptionDescription_costTaxIncluded_label`,
                translations,
              )}`;
          break;
        case 'subscrition':
          textFrequency = hasClaroAdActive
            ? `${price?.currency || ''} ${price?.amount ||
                ''} ${translation?.labelTaxes ||
                ''} ${translation?.labelTemporality || ''}`
            : `${currency || ''}${price || ''} ${getTranslation(
                // /
                `subscription_${producttype}_periodicitySeparator_${periodicity}_label`,
                translations,
              )} ${getTranslation(
                //  mes
                `subscription_${producttype}_${periodicity}_label`,
                translations,
              )} ${getTranslation(
                // IVA Incluido
                `${producttype}_subscriptionDescription_costTaxIncluded_label`,
                translations,
              )}`;
          break;
        default:
          textFrequency = hasClaroAdActive
            ? `${price?.currency || ''} ${price?.amount ||
                ''} ${translation?.labelTaxes || ''}`
            : `${currency || ''}${price || ''} ${getTranslation(
                `${producttype}_subscriptionDescription_costTaxIncluded_label`,
                translations,
              )}`;
      }

      setKeys({
        logo,
        amount: textFrequency || '',
        bonus: bonusText || '',
        description: description || '',
        gateway:
          `ticket_subscription_${currentPayment?.currentWFS?.gateway ||
            purchaseResponse?.data?.paymentMethodData?.gateway ||
            workflow?.selectedPaymentMethod}_label` || '',
        account: account || '',
        endDate: endDate || '',
        accept: acceptTxt || '',
      });
    },
    [currentPayment, seriesContent, unitarioContent],
  );

  const redirectSuscription = () => {
    refreshEpg()
    const params = getQueryParamsObject(searchParams);

    const groupId = params?.group_id || groupIdFromProps;
    const playerUrl = params?.player_url || playerUrlFromProps;

    const { node_id } = purchaseResponse?.data || {};

    if (is2faFlow) {
      hidePortal();
    }

    if (returnTo) {
      return navigate(`/${GetRegion()}${PLAYER_SEGMENT}${returnTo}`, {
        replace: true,
      });
    }

    if (node_id && !playerUrl) {
      const nodes = _.find(navigation, { code: 'playandgo' }) || {};
      const node = nodes.childs && _.find(nodes.childs, { id: node_id });
      if (node) return navigate(`/${GetRegion()}/${node.code}`);
    }

    if (playerUrl) {
      if (groupId) {
        return navigate(
          decodeURIComponent(`${playerUrl}?payment=1`, { replace: true }),
        );
      }
      return window.location.replace(decodeURIComponent(playerUrl));
    }

    if (groupId) {
      return window.location.replace(
        ClaroUrlBuilder.card(GetRegion(), groupId),
      );
    }

    const firstNode = getFirstNode()
    navigate(`/${GetRegion()}/${firstNode}`);
  };

  const closeScreen = () => {
    refreshEpg()
    const group_id = searchParams.get('group_id');
    const isPlayerPath = location.pathname.includes('/watch/');

    const groupId = group_id || groupIdFromProps;

    if (is2faFlow && isPlayerPath) return hideAndResume();

    if (is2faFlow && !group_id && groupIdFromProps) return hidePortal();

    if (groupId) {
      hidePortal();
      return window.location.replace(
        ClaroUrlBuilder.card(GetRegion(), groupId),
      );
    }

    const firstNode = getFirstNode()
    return navigate(`/${GetRegion()}/${firstNode}`);;
  };

  const redirectRent = () => {
    const params = getQueryParamsObject(searchParams);

    if (is2faFlow) {
      hidePortal();
    }
    const groupId = params?.group_id || groupIdFromProps;
    const playerUrl = params?.player_url || playerUrlFromProps;
    const isMobile = Utils.MobileCheck();
    if (isMobile) {
      return navigate(
        `/${GetRegion()}/devices?runplayerinapp&group_id=${groupId}`,
      );
    }

    if (groupId && playerUrl) {
      return navigate(
        decodeURIComponent(`${playerUrl}?payment=1`, { replace: true }),
      );
    }

    window.location.replace(ClaroUrlBuilder.home());
  };
  const accept = () => {
    let isCupon = purchaseResponse?.data?.pincode;
    const infoPaymentEventGA = {
      event: 'purchase',
      value: currentPayment?.currentPBI?.price,
      transaction_id: purchaseResponse?.data?.uuid,
      coupon: isCupon ? isCupon : 'no aplica',
      item_name: currentPayment?.currentPBI?.producttype,
      price: currentPayment?.currentPBI?.price,
      item_brand: currentPayment?.currentPBI?.producttype,
      item_category: 'no aplica',
      item_category2: 'no aplica',
      item_category3: `por suscripcion ${
        currentPayment?.currentPBI?.producttype
      }`,
      item_category4: 'no aplica',
      quantity: '1',
    };
    const { oneoffertype } = currentPayment.currentPBI;
    hidePortal();
    if (oneoffertype === 'subscrition') {
      pushGTMEvent({
        ...infoPaymentEventGA,
        item_id: workflow?.list[0]?.product_id,
      });
      redirectSuscription();
      return;
    }

    pushGTMEvent({
      ...infoPaymentEventGA,
      item_id: workflow?.workflow?.listBuyLinks[0]?.product_id,
    });
    redirectRent();
    handleClear();
  };

  let marginBonus = 0;
  if (
    currentPayment?.currentWFS?.gateway === 'promogate' &&
    currentPayment?.currentPBI?.oneoffertype !== 'subscrition'
  ) {
    marginBonus = '140px';
  } else if (
    currentPayment?.currentWFS?.gateway !== 'promogate' &&
    currentPayment?.currentPBI?.oneoffertype !== 'subscrition'
  ) {
    marginBonus = '32px';
  }

  const elements = [
    {
      element: 'title',
      content: getTranslation('ticket_subscription_title', translations),
      position: 'center',
      style: {
        marginBottom: '16px',
        flexGrow: 0,
      },
    },
    {
      element: 'message',
      content: keys?.logo || '',
      style: {
        marginBottom: '23px',
      },
    },
    {
      element: 'message',
      content: keys?.bonus || '',
      style: {
        marginBottom: '14px',
        marginTop: marginBonus,
      },
      expand: 0.01,
    },
    (currentPayment?.currentWFS?.gateway !== 'promogate' ||
      currentPayment?.currentPBI?.oneoffertype === 'subscrition') && {
      element: 'message',
      content: keys?.description || '',
      expand: 2,
      style: {
        fontSize: '14px',
        color: '#EEEEEE',
        marginBottom:
          currentPayment?.currentPBI?.oneoffertype === 'subscrition'
            ? '32px'
            : '83px',
        marginTop:
          currentPayment?.currentPBI?.oneoffertype === 'subscrition'
            ? '0px'
            : '32px',
      },
    },
    currentPayment?.currentWFS?.gateway !== 'promogate' && {
      element: 'message',
      content: `<div class="ticket--info">${getTranslation(
        'subscription_totalCost_description_label',
        translations,
      )} <span>${keys?.amount || ''}</span></div>`,
      position: 'right',
      expand: 0.2,
      style: {
        lineHeight: 2,
        paddingLeft: '20px',
      },
    },
    {
      element: 'message',
      content: `<div class="ticket--info">${getTranslation(
        'ticket_subscription_paymentMethod_label',
        translations,
      )}</div>`,
      position: 'left',
      expand: 0.2,
      style: {
        lineHeight: 2,
        paddingLeft: '20px',
      },
    },
    {
      element: 'message',
      content: `<div class="ticket--info"><span>
      ${getTranslation(keys?.gateway, translations)} 
      ${keys?.account || ''}</span></div>`,
      position: 'right',
      expand: 0.2,
      style: {
        lineHeight: 2,
        paddingLeft: '20px',
      },
    },
    {
      element: 'message',
      content: `<div class="ticket--info">
      ${getTranslation('ticket_subscription_nextPayment_label', translations)} 
      <span>${keys?.endDate || ''}</span></div>`,
      position: 'left',
      expand: 0.2,
      style: {
        paddingLeft: '20px',
        lineHeight: 2,
      },
    },

    {
      element: 'button',
      type: 'register',
      content: keys?.accept || '',
      onClick: accept,
      style: {
        marginTop: '33px',
        marginBottom: '32px',
      },
    },
    (searchParams.get('player_url') || playerUrlFromProps) && {
      element: 'button',
      type: 'gray',
      content: getTranslationEmptyOrNullKey(
        'Transaccionales_Ticket_TextoBotonSecundarioCerrar',
        translations,
      ),
      onClick: closeScreen,
      expand: 0.1,
    },
  ];

  return (
    <div className="PaymentFormContainer">
      <div className="customForm ticketForm">
        <Form elements={elements} />
      </div>
    </div>
  );
};

ConfirmTransaction.propTypes = {
  asset: PropTypes.object,
  translations: PropTypes.object,
};

export default WithApa(ConfirmTransaction);
